import React from "react";
import { BaseEditorComponent } from "@handsontable/react";
import AddCommentIcon from "@material-ui/icons/AddComment";
import ChatIcon from "@material-ui/icons/Chat";
import { tesaBlue, tesaDark } from "../../../../../../styles/colors";
import StyledTooltip from "../../../../../../components/Wrapper/StyledTooltip";

interface NoteCustomValue {
  repetitionNumber: number;
  testResultRowId: number;
  text: string;
}

interface NoteRendererComponentProps {
  value?: string;
  col?: number;
  row?: number;
  TD?: HTMLTableDataCellElement;
  readOnly: boolean;
}
export class NoteRendererComponent extends BaseEditorComponent<NoteRendererComponentProps> {
  get value(): NoteCustomValue {
    const { value } = this.props as NoteRendererComponentProps;
    return value ? (JSON.parse(value) as NoteCustomValue) : { repetitionNumber: 0, testResultRowId: 0, text: "" };
  }

  render(): React.ReactElement | undefined {
    const { readOnly, TD } = this.props as NoteRendererComponentProps;
    const { text } = this.value;
    if (TD) {
      TD.style.textAlign = "center";
    }

    const render = () => {
      if (text) {
        return (
          <ChatIcon
            fontSize="small"
            style={{
              cursor: "pointer",
              color: tesaDark,
              transform: "translateY(5px)",
            }}
          />
        );
      }
      if (readOnly) {
        return <></>;
      }
      return (
        <AddCommentIcon
          fontSize="small"
          style={{
            cursor: "pointer",
            color: tesaBlue,
            transform: "translateY(5px)",
          }}
        />
      );
    };

    return <StyledTooltip title="Add Note on Repetition">{render()}</StyledTooltip>;
  }
}
export default NoteRendererComponent;
